<script lang="ts">
  import RadioGroup from "../../components/RadioGroup.svelte";
  import ComboListInput from "../../components/ComboListInput.svelte";
  import Info from "~icons/ph/info-bold";
  import Warning from "~icons/ph/warning-bold";
  import ArrowRight from "~icons/ph/arrow-right-bold";
  import FooterButtons from "../../components/workflow/FooterButtons.svelte";
  import CloseButton from "../../components/CloseButton.svelte";
  import ContinueButton from "../../components/workflow/ContinueButton.svelte";
  import { getStep } from "../../lib/workflow/workflowLib.svelte";

  let {
    selectedOption = $bindable(),
    errors,
    financeCompanyOptions,
  }: {
    selectedOption?: string;
    errors: { [key: string]: string } | undefined;
    financeCompanyOptions: string[];
  } = $props();

  const step = getStep();
  const type = $derived(selectedOption === "not_sure" ? "button" : "submit");
  const label = $derived(selectedOption === "not_financed" ? "Done" : "Continue");
</script>

<h2 class="ui-title">Identify finance company</h2>

<fieldset class="ui-fieldset mb-6">
  <legend>Do you know the name of the finance company for this vehicle?</legend>
  <RadioGroup
    name="finance_company_known"
    options={[
      ["Yes", "yes"],
      ["Not sure", "not_sure"],
      ["I didn't finance this vehicle; I purchased it outright", "not_financed"]
    ]}
    bind:group={selectedOption}
    required
    error={errors?.finance_company_known || errors?.no_finance_company}
  />
</fieldset>

<div class="ui-content-options">
  <fieldset class="ui-fieldset" disabled={selectedOption !== "yes"}>
    <legend>Finance company name</legend>
    <ComboListInput
      name="finance_company_name"
      options={financeCompanyOptions}
      allowNew={false}
      maxlength={105}
      placeholder="Type to search"
      required
    >
      {#snippet noResults()}
        <div class="w-full px-4 py-2">
          <div class="font-normal text-gray-500">No matching results</div>
          <button
            type="button"
            class="text-blue-600 underline font-semibold flex gap-2 items-center"
            onclick={() => step.next()}
          >
            Help me find my finance company
            <ArrowRight class="w-4 h-4" />
          </button>
        </div>
      {/snippet}
    </ComboListInput>
    {#if errors?.finance_company_name}<div class="ui-error">{errors.finance_company_name}</div>{/if}
  </fieldset>

  <fieldset disabled={selectedOption !== "not_sure"}>
    <div class="ui-alert ui-alert-info">
      <Info />
      No problem. Since we need the name of your finance company for this claim, continue below and we’ll try to help
      you find it.
    </div>
  </fieldset>

  <fieldset disabled={selectedOption !== "not_financed"}>
    <div class="ui-alert ui-alert-warning">
      <Warning />
      Car finance mis-selling claims only apply to PCP or hire-purchase agreements. If you’re sure you didn’t finance
      this vehicle, click “Done” to request we close this case.
    </div>
  </fieldset>
</div>

{#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

<FooterButtons back={false}>
  <CloseButton label="Cancel" />
  <ContinueButton {type} {label} name="step" value="finance_company_name" />
</FooterButtons>

<style>
  fieldset[disabled] { visibility: hidden; }
</style>